module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event_detail_photo-9d98a9fc6e2a4f06bbf9ccdb26c5dfb8.jpg";